// extracted by mini-css-extract-plugin
export default {"button":"NavButton_button__9W7QR","dark":"NavButton_dark__qLNpo"};